import React, {useState} from 'react';
import ReactSelect from 'react-select/async';

import {FieldProp} from '../../../types';
import {Etl} from '../../../_services/Etl';
import {NestedForm} from '../NestedForm';

type ContingencySearchProps = FieldProp & {};

export const ContingencySearch: React.FunctionComponent<ContingencySearchProps> = ({
                                                                                       value,
                                                                                       onChange,
                                                                                       form,
                                                                                       formState,
                                                                                       ...rest
                                                                                   }): JSX.Element => {

    const [localFormState, setLocalFormState] = useState({
        contingencyWorkflow: {},
        contingencyLines: []
    });

    return (
        <>
            <div>
                <label>
                    <div>Contingency Workflow</div>
                    <small className="d-block">
                        Search for Contingency Workflow by Workflow#, CSO#, Project Name or Customer#
                    </small>
                    <ReactSelect
                        placeholder="Select a Workflow Step..."
                        required={true}
                        isClearable={true}
                        loadOptions={(searchValue) => {
                            return Etl.getInstance().process('change_order_contingency_autocompleter', {q: searchValue})
                                .then(response => {
                                    return response.json.result.map(item => ({
                                        value: item.id,
                                        label: item.id,
                                        text: item.id,
                                        ...item
                                    }));
                                })
                        }}
                        defaultOptions
                        value={localFormState?.contingencyWorkflow}
                        onChange={(option) => {
                            setLocalFormState(s => ({
                                ...s,
                                contingencyWorkflow: option
                            }))
                        }}
                    />
                </label>
            </div>
            {localFormState?.contingencyWorkflow &&
                <NestedForm
                    {...rest}
                    value={localFormState?.contingencyLines}
                    onChange={(v) => {
                        setLocalFormState(s => ({
                            ...s,
                            contingencyLines: v
                        }));
                    }}
                    additionalButtons={[]}
                    form={form}
                    formState={formState}
                />
            }
        </>
    )
}